export default __webpack_public_path__ + "static/media/multi-real.1f8d7ceb.png";